// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a42c211f","952":"7d4554fa"}[chunkId] + ".chunk.js";
};